import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const API = "https://happyhorizon.co.in/api";
const BASE_URL = "https://happyhorizon.co.in";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const carouselRef = useRef(null);

  useEffect(() => {
    fetch(`${API}/get_images.php`)
      .then(res => res.json())
      .then(data => {
        const imageArray = Array.isArray(data) ? data : data?.images || [];
        setImages(imageArray.slice(0, 12));
        console.log("Fetched images:", imageArray.slice(0, 12));
      })
      .catch(err => {
        console.error("Failed to fetch images:", err);
        setImages([]);
      });
  }, []);

  // Initialize Bootstrap carousel
  useEffect(() => {
    if (images.length > 0 && carouselRef.current) {
      try {
        const carouselElement = carouselRef.current;
        // Destroy existing carousel instance if it exists
        const existingCarousel = window.bootstrap?.Carousel.getInstance(carouselElement);
        if (existingCarousel) {
          existingCarousel.dispose();
        }
        // Create new carousel instance
        new window.bootstrap.Carousel(carouselElement, {
          interval: 5000, // Auto-play every 5 seconds
          wrap: true
        });
      } catch (err) {
        console.error("Bootstrap carousel initialization error:", err);
      }
    }
  }, [images]);

  return (
    <div style={styles.container}>
      <div style={styles.section}>
        <h2 style={styles.title}>Gallery</h2>
        <p style={styles.subtitle}>Our Beautiful Moments</p>

        {/* BOOTSTRAP CAROUSEL */}
        <div
          ref={carouselRef}
          id="galleryCarousel"
          className="carousel slide"
          style={styles.carouselWrapper}
        >
          {/* CAROUSEL INDICATORS */}
          <div className="carousel-indicators">
            {images.map((_, i) => (
              <button
                key={i}
                type="button"
                data-bs-target="#galleryCarousel"
                data-bs-slide-to={i}
                className={i === 0 ? "active" : ""}
                aria-current={i === 0 ? "true" : "false"}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>

          {/* CAROUSEL INNER */}
          <div className="carousel-inner">
            {images.map((img, i) => (
              <div
                key={img.id}
                className={`carousel-item ${i === 0 ? "active" : ""}`}
              >
                <div style={styles.carouselItemContent}>
                  <img
                    src={`${BASE_URL}/${img.url}`}
                    alt={`Gallery item ${i + 1}`}
                    style={styles.carouselImage}
                    onClick={() => setActiveIndex(i)}
                  />
                  <div
                    style={styles.imageOverlay}
                    onClick={() => setActiveIndex(i)}
                  >
                    <span style={styles.zoomIcon}>🔍 Click to View</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CAROUSEL CONTROLS */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#galleryCarousel"
            data-bs-slide="prev"
            style={styles.carouselControl}
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#galleryCarousel"
            data-bs-slide="next"
            style={styles.carouselControl}
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* FULLSCREEN LIGHTBOX */}
      {activeIndex !== null && (
        <Lightbox
          images={images}
          index={activeIndex}
          onClose={() => setActiveIndex(null)}
          setIndex={setActiveIndex}
        />
      )}
    </div>
  );
}

/* ================= LIGHTBOX ================= */

function Lightbox({ images, index, setIndex, onClose }) {
  const img = images[index];

  const prev = e => {
    e.stopPropagation();
    setIndex(i => (i > 0 ? i - 1 : images.length - 1));
  };

  const next = e => {
    e.stopPropagation();
    setIndex(i => (i + 1) % images.length);
  };

  const handleImageClick = e => {
    e.stopPropagation();
  };

  return (
    <div style={styles.lightbox} onClick={onClose}>
      <button
        style={{ ...styles.nav, left: 20 }}
        onClick={prev}
        aria-label="Previous image"
      >
        ‹
      </button>

      <div style={styles.lightboxImageContainer}>
        <img
          src={`${BASE_URL}/${img.url}`}
          alt="Gallery lightbox view"
          style={styles.lightboxImg}
          onClick={handleImageClick}
        />
      </div>

      <button
        style={{ ...styles.nav, right: 20 }}
        onClick={next}
        aria-label="Next image"
      >
        ›
      </button>

      <span style={styles.close} onClick={onClose}>
        ✕
      </span>

      <div style={styles.imageCounter}>
        {index + 1} / {images.length}
      </div>
    </div>
  );
}
const styles = {
  container: {
    width: "100%",
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    padding: "60px 20px",
    maxheight: "70vh",
  },

  section: {
    maxWidth: 1000,
    margin: "0 auto"
  },

  title: {
    fontSize: 42,
    fontWeight: 800,
    textAlign: "center",
    marginBottom: 8,
    color: "#1a202c"
  },

  subtitle: {
    fontSize: 16,
    textAlign: "center",
    color: "#718096",
    marginBottom: 50
  },

  carouselWrapper: {
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 15px 40px rgba(0, 0, 0, 0.2)",
    background: "#000"
  },

  carouselItemContent: {
    position: "relative",
    width: "100%",
    paddingBottom: "50%",
    overflow: "hidden"
  },

  carouselImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer",
    transition: "transform 0.3s ease"
  },

  imageOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    cursor: "pointer",
    opacity: 0
  },

  zoomIcon: {
    fontSize: 24,
    color: "#fff",
    fontWeight: "500"
  },

  carouselControl: {
    background: "rgba(0, 0, 0, 0.4)"
  },

  /* LIGHTBOX */
  lightbox: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    animation: "fadeIn 0.3s ease"
  },

  lightboxImageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    padding: "60px 80px"
  },

  lightboxImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: 8,
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
    animation: "slideInZoom 0.5s ease-out"
  },

  nav: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 44,
    background: "rgba(255, 255, 255, 0.2)",
    border: "none",
    color: "#fff",
    padding: "12px 18px",
    cursor: "pointer",
    borderRadius: 8,
    transition: "all 0.3s ease",
    zIndex: 10000
  },

  close: {
    position: "absolute",
    top: 30,
    right: 30,
    fontSize: 36,
    color: "#fff",
    cursor: "pointer",
    transition: "all 0.3s ease",
    zIndex: 10001
  },

  imageCounter: {
    position: "absolute",
    bottom: 30,
    left: "50%",
    transform: "translateX(-50%)",
    color: "#fff",
    fontSize: 14,
    background: "rgba(0, 0, 0, 0.5)",
    padding: "8px 16px",
    borderRadius: 20,
    zIndex: 10000
  }
};
